export default __webpack_public_path__ + "images/1bef42df397382d02b65f2716794623e.png";